const downloadLink = async ({ token, caseNo, versionId, platform }) => {
  try {
    const response = await fetch(
      `https://lvdmsup.nablasol.net/DMS/api/request_document_download?caseNo=${caseNo}&versionId=${versionId}&platform=${platform}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default downloadLink;
